import { DeepPartial } from '@reduxjs/toolkit';

export enum EDisplay {
  Both = 'Both',
  LoggedIn = 'Logged in',
  LoggedOut = 'Logged Out',
}

export enum EStatus {
  Active = 'Active',
  Draft = 'Draft',
  Scheduled = 'Scheduled',
}

export type TDeviceMedia = {
  name?: string;
  base64?: string;
  content?: string;
  link?: string;
  publicUrl?: string;
  isTwoLayer?: boolean;
  animatedLayerBase64?: string;
  layerLink?: string;
  layerName?: string;
};
export type TMedia = {
  desktop?: TDeviceMedia;
  mobile?: TDeviceMedia;
  app?: TDeviceMedia;
};

export type TData = {
  id: string;
  title: string;
  location: string[];
  states?: string[];
  media: TMedia;
  display: EDisplay;
  status: EStatus | undefined;
  punter_category: string[];
  description?: string;
  terms_and_conditions?: string;
  button_text?: string;
  button_link?: string;
  start_date?: string | undefined;
  end_date?: string | undefined;
  available_on?: string[];

  has_money_back_promo?: boolean;
  money_back_promo_id?: string;
  has_treasure_hunt_promo?: boolean;
  treasure_hunt_promo_id?: string;
};

export type TAddPromoParams = DeepPartial<{
  content: string;
  contentType: string;
  contentBase64: string;
  version: number | null;
}>;

export type TUploadMediaParams = DeepPartial<
  {
    name: string;
    contentBase64: string;
    contentType: string;
  }[]
>;

export type TUploadMediaData = DeepPartial<
  {
    name: string;
    image: string;
    device: string;
    publicUrl?: string;
    layerName?: string;
    layerLink: string;
  }[]
>;
